export enum UserTaskDecision {
  ENDPROCESS = 'ENDPROCESS',

  AGREE = 'AGREE',

  DISAGREE = 'DISAGREE',

  CARERSELECTION = 'CARERSELECTION',
}
